import {
  BaseQueryFn,
  QueryActionCreatorResult,
  QueryDefinition,
} from '@reduxjs/toolkit/query';
import {
  ComponentType,
  CSSProperties,
  MutableRefObject,
  ReactNode,
  SVGProps,
} from 'react';
import CSS from 'csstype';
import { IOption, SelectProps } from 'src/components/UI/Select/Select';
import { DatePickerComponentProps } from 'src/components/UI/DatePickerComponent/DatePickerComponent';
import { InputProps } from 'src/UI/Input/Input';
import { UseAsyncSelectProps } from 'src/hooks/useAsyncSelect';

export interface AsyncSelectEvent {
  key?: string;
  value?: string | number | null;
}
export interface PageTable {
  refetch?: () => QueryActionCreatorResult<
    QueryDefinition<unknown, BaseQueryFn<unknown>, string, unknown>
  >;
  tableRef?: MutableRefObject<any>;
  dataLoading?: boolean;
}
export interface TableDataItemElement {
  element?: ReactNode;
  text?: string | number | null;
  afterElement?: ReactNode;
  className?: string;
  innerClassName?: string;
  sortValue?: any;
  enableTooltip?: boolean;
  xAlign?: 'left' | 'right' | 'center' | 'space-between';
  yAlign?: 'flex-start' | 'flex-end' | 'stretch' | 'baseline' | 'center';
}
export interface TableDataItemElements {
  [key: string]: TableDataItemElement;
}
export type TableDataItem = {
  data: {
    id: string | number;
    value?: any;
    isDisabled?: boolean;
    style?: CSS.Properties;
    className?: string;
    // onDoubleClick?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onClick?: () => void;
  };
  elements: TableDataItemElements;
};
export enum FilterTypes {
  TEXT = 'text',
  SELECT = 'select',
  SELECT_COUNTRY = 'country',
  SELECT_ASYNC = 'async',
  DATE = 'date',
  DATE_RANGE = 'date-range',
}

export interface FilterConfig {
  type: FilterTypes;
  parameterName?: string;
  innerOptionsId?: string;
  selectConfig?: Partial<SelectProps>;
  dataConfig?: Partial<DatePickerComponentProps>;
  inputConfig?: Partial<InputProps>;
  config?: {
    style?: CSSProperties;
    className?: string;
  };
}

export interface ThConfig {
  element: ReactNode | string;
  columnId: string;
  filter?: FilterConfig | FilterConfig[];
  width?: number | string;
  minWidth?: number | string;
}
export interface TableConfig {
  th: ThConfig[];
  disableFilters?: boolean;
  tableName?: string;
  hasSort?: boolean;
  hasSelection?: boolean;
}
export interface FilterOptions {
  [key: string]: IOption[] | IOption[][];
}
export enum SortFieldTypes {
  ASC = 'asc',
  DESC = 'desc',
}
export interface SortField {
  columnId: string;
  type: null | SortFieldTypes;
}
export interface SortFields {
  [key: string]: SortField | null;
}
export interface AsyncFilters {
  [key: string]: UseAsyncSelectProps;
}
export interface TableProps {
  config: TableConfig;
  tableData: TableDataItem[];
  dataLoading?: boolean;
  filterOptions?: FilterOptions;
  asyncFilters?: AsyncFilters;
  className?: string;
  disableNoWrap?: boolean;
  tableRef?: MutableRefObject<any>;
  rowHeight?: 'disabled' | number;
  actionsCount?: number;
  virtuosoOverflow?: string;
  customEditIcon?: ComponentType<SVGProps<SVGSVGElement>>;
  customDeleteIcon?: ComponentType<SVGProps<SVGSVGElement>>;
  actionStyles?: string;
}
